import React from 'react';
import ReactDOM from 'react-dom/client';
import VerifyProfile from './VerifyProfile';
import AttendancePage from "./AttendancePage";
import AdminDashboard from './AdminDashboard';


import './index.css';
import App from './App'; // Your main workshop file
import IdentityCard from './id'; // Your separate ID file
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AttendanceDashboard from './AttendanceDashboard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Route for Main Landing & Admin Panel */}
        <Route path="/" element={<App />} />
        <Route path="/admin" element={<AdminDashboard />} />
        
        {/* Route for the Digital ID Card */}
        <Route path="/id-card/:userId" element={<IdentityCard />} />
        <Route path="/verify/:userId" element={<VerifyProfile />} />
        <Route path="/attendance" element={<AttendancePage />} />
        <Route path="/attendance-dashboard" element={<AttendanceDashboard />} />


      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);


